import React, {Component} from 'react';
import {connect} from "react-redux";
import {endpointFieldChange} from "../../../../store/actions/endpoints";

const Action = ( props ) => {

	const { id, action, endpointFieldChange, sectionVisibility, premium } = props;

	const endpointActions = {
		posts: [
			{
				name:  'Create',
				value: 'create_post',
				description: 'Use this action if you want to create an endpoint for creating a post'
			},
			{
				name:  'Display',
				value: 'display_data',
				description: 'Use this action if you want to create an endpoint for displaying posts'
			},
			{
				name:  'Edit',
				value: 'edit_post',
				description: 'Use this action if you want to create an endpoint for editing a post'
			},
		],
		taxonomies: [
			{
				name:  'Create',
				value: 'create_taxonomies',
				description: 'Use this action if you want to create an endpoint for creating taxonomy terms'
			},
			{
				name:  'Display',
				value: 'display_taxonomies',
				description: 'Use this action if you want to create an endpoint for displaying taxonomy terms'
			},
		],
		users: [
			{
				name:  'Create',
				value: 'create_users',
				description: 'Use this action if you want to create an endpoint creating users'
			},
			{
				name:  'Display',
				value: 'display_users',
				description: 'Use this action if you want to create an endpoint for displaying users'
			},
			{
				name:  'Edit',
				value: 'edit_users',
				description: 'Use this action if you want to create an endpoint for editing users'
			},
		],
		customTable: [
			{
				name:  'Create',
				value: 'create_custom_table',
				description: 'Use this action if you want to create an endpoint for inserting data into any custom database tables'
			},
			{
				name:  'Delete',
				value: 'delete_custom_table',
				description: 'Use this action if you want to create an endpoint for deleting data from custom database tables'
			},
			{
				name:  'Display',
				value: 'display_custom_table',
				description: 'Use this action if you want to create an endpoint for displaying data from your custom database tables'
			},
			{
				name:  'Edit',
				value: 'edit_custom_table',
				description: 'Use this action if you want to create an endpoint for editing data from custom database tables'
			},
		],
		advanced: [
      {
        name:  'Custom SQL Query',
        value: 'custom_sql_query',
        description: 'This action can be used to perform custom SQL queries to display, update, create or delete table entries'
      },
			{
				name:  'REST API call',
				value: 'rest_api_call',
				description: 'Use this action if you want to create an endpoint for editing data from custom database tables'
			},
		]
	};

	const getCurrentDesc = () => {
		let title = endpointActions.posts.filter(el => el.value === action)[0]?.value ||
			endpointActions.taxonomies.filter(el => el.value === action)[0]?.value ||
			endpointActions.users.filter(el => el.value === action)[0]?.value ||
			endpointActions.customTable.filter(el => el.value === action)[0]?.value ||
			endpointActions.advanced.filter(el => el.value === action)[0]?.value;

		title = title.replaceAll('_', ' ');
		title = title.charAt(0).toUpperCase() + title.slice(1);

		const desc = endpointActions.posts.filter(el => el.value === action)[0]?.description ||
			endpointActions.taxonomies.filter(el => el.value === action)[0]?.description ||
			endpointActions.users.filter(el => el.value === action)[0]?.description ||
			endpointActions.customTable.filter(el => el.value === action)[0]?.description ||
			endpointActions.advanced.filter(el => el.value === action)[0]?.description;

		return `${title}: ${desc}`;
	}

  const freeTypes = [
    'create_post',
    'display_data',
    'edit_post',
    'create_taxonomies',
    'display_taxonomies',
    'create_users',
    'display_users',
    'edit_users',
  ]

	return (
		<div id="poststuff" className="action-box">
			<div id="slugdiv" className="postbox ">
				<h2 className="hndle ui-sortable-handle" onClick={ e => endpointFieldChange( !sectionVisibility, id, 'actionSection' ) }><span>Endpoint Type</span></h2>
				<div className="inside" style={{display: sectionVisibility ? 'block' : 'none'}}>
					<p>Here is where you define the heart of your endpoint. This option will unlock you features that are supposed to be used to a particular kind of endpoint.</p>
					<select onChange={ e => (premium || freeTypes.indexOf(e.target.value) !== -1) && endpointFieldChange( e.target.value, id, 'action' ) } value={action}>
						<optgroup label="Posts">
							{endpointActions.posts.map((m, index) => <option key={m.value} value={m.value}>{m.name}</option>)}
						</optgroup>
						<optgroup label="Taxonomies">
							{endpointActions.taxonomies.map((m, index) => <option key={m.value} value={m.value}>{m.name}</option>)}
						</optgroup>
						<optgroup label="Users">
							{endpointActions.users.map((m, index) => <option key={m.value} value={m.value}>{m.name}</option>)}
						</optgroup>
						<optgroup disabled={!premium ? 'disabled' : ''} label="Custom Table">
							{endpointActions.customTable.map((m, index) => <option disabled={!premium ? 'disabled' : ''} key={m.value} value={m.value}>{m.name} {!premium ? '(PRO)' : ''}</option>)}
						</optgroup>
						<optgroup disabled={!premium ? 'disabled' : ''} label="Advanced">
							{endpointActions.advanced.map((m, index) => <option disabled={!premium ? 'disabled' : ''} key={m.value} value={m.value}>{m.name} {!premium ? '(PRO)' : ''}</option>)}
						</optgroup>
					</select>
					<p>
						{getCurrentDesc()}
					</p>

				</div>
			</div>
		</div>
	);
};

const mapStateToProps = ( state, props ) => ({
	id: props.id,
	action: state.settings.endpoints[props.id].action,
	sectionVisibility: state.settings.endpoints[props.id].actionSection,
  premium: state.premium
});

const mapDispatchToProps = dispatch => ({
	endpointFieldChange: ( value, endpointId, field ) => dispatch( endpointFieldChange( value, endpointId, field ) ),
});

export default connect( mapStateToProps, mapDispatchToProps )(Action);
